<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  background: #020b1a;
}

#app {
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e8f4ff;
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #020b1a;
  box-sizing: border-box;
  white-space: nowrap;
}
</style>
